import React from 'react';
import { Link } from 'react-router-dom';
import './Terms.css';

const Terms = () => {
  return (
    <div className="terms-page">
      <div className="terms-container">
        <h1>Terms of Use</h1>
        <div className="terms-content">
          <section>
            <p className="last-updated">Last Updated: {new Date().toLocaleDateString()}</p>
          </section>

          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using FeatureMap, you accept and agree to be bound by the terms 
              and provision of this agreement. If you do not agree to abide by the above, please 
              do not use this service.
            </p>
          </section>

          <section>
            <h2>2. Use License</h2>
            <p>
              Permission is granted to use FeatureMap for personal and commercial purposes, 
              subject to the following restrictions:
            </p>
            <ul>
              <li>You must not use the service for any unlawful purpose or in violation of any laws</li>
              <li>You must not attempt to gain unauthorized access to any part of the service</li>
              <li>You must not interfere with or disrupt the service or servers</li>
              <li>You must not use the service to transmit any malicious code or harmful content</li>
              <li>You must respect the intellectual property rights of others</li>
            </ul>
          </section>

          <section>
            <h2>3. User Accounts</h2>
            <p>
              You are responsible for:
            </p>
            <ul>
              <li>Maintaining the confidentiality of your account credentials</li>
              <li>All activities that occur under your account</li>
              <li>Providing accurate and complete information when creating your account</li>
              <li>Notifying us immediately of any unauthorized use of your account</li>
            </ul>
          </section>

          <section>
            <h2>4. User Content</h2>
            <p>
              You retain ownership of any content you create or upload to FeatureMap. However, 
              by using the service, you grant us a license to:
            </p>
            <ul>
              <li>Store, process, and display your content as necessary to provide the service</li>
              <li>Share your content with other members of your feature groups as determined by group settings</li>
              <li>Use aggregated, anonymized data for service improvement</li>
            </ul>
            <p>
              You are responsible for ensuring that your content does not violate any laws or 
              infringe on the rights of others.
            </p>
          </section>

          <section>
            <h2>5. Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Use the service to transmit spam, malware, or other harmful content</li>
              <li>Impersonate any person or entity</li>
              <li>Harass, abuse, or harm other users</li>
              <li>Violate any applicable laws or regulations</li>
              <li>Reverse engineer, decompile, or attempt to extract source code</li>
            </ul>
          </section>

          <section>
            <h2>6. Service Availability</h2>
            <p>
              We strive to provide reliable service but do not guarantee that the service will 
              be available at all times. We may perform maintenance, updates, or modifications 
              that may temporarily interrupt service. We are not liable for any downtime or 
              service interruptions.
            </p>
          </section>

          <section>
            <h2>7. Intellectual Property</h2>
            <p>
              The FeatureMap service, including its design, features, and functionality, is 
              owned by us and protected by copyright, trademark, and other intellectual property laws. 
              You may not copy, modify, or create derivative works without our express written permission.
            </p>
          </section>

          <section>
            <h2>8. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, FeatureMap and its providers shall not be 
              liable for any indirect, incidental, special, consequential, or punitive damages, 
              including loss of profits, data, or use, arising out of or related to your use of the service.
            </p>
          </section>

          <section>
            <h2>9. Indemnification</h2>
            <p>
              You agree to indemnify and hold harmless FeatureMap, its officers, directors, 
              employees, and agents from any claims, damages, losses, liabilities, and expenses 
              (including legal fees) arising out of your use of the service or violation of these terms.
            </p>
          </section>

          <section>
            <h2>10. Termination</h2>
            <p>
              We reserve the right to terminate or suspend your account and access to the service 
              at any time, with or without cause or notice, for any reason including violation of 
              these terms. Upon termination, your right to use the service will immediately cease.
            </p>
          </section>

          <section>
            <h2>11. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. We will notify users of 
              material changes by posting the updated terms on this page and updating the 
              "Last Updated" date. Your continued use of the service after changes constitutes 
              acceptance of the new terms.
            </p>
          </section>

          <section>
            <h2>12. Governing Law</h2>
            <p>
              These terms shall be governed by and construed in accordance with applicable laws, 
              without regard to conflict of law provisions.
            </p>
          </section>

          <section>
            <h2>13. Contact Information</h2>
            <p>
              If you have questions about these Terms of Use, please contact your feature group 
              administrator or reach out through your account settings.
            </p>
          </section>

          <div className="terms-footer">
            <Link to="/" className="back-link">
              <i className="fas fa-arrow-left"></i> Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;





